/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Tlm_1Inputs */

const en_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data_layer`)
};

const ar_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طبقة البيانات`)
};

const bn_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data_layer`)
};

const de_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`data_layer`)
};

const es_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`capa_datos`)
};

const fr_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`couche_données`)
};

const pt_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`camada de dados`)
};

const zh_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据层`)
};

const tr_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`veri_katmanı`)
};

const ru_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`слой_данных`)
};

const pl_svc_ai_app_rescue_tlm_1 = /** @type {(inputs: Svc_Ai_App_Rescue_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`warstwa_danych`)
};

/**
* | output |
* | --- |
* | "data_layer" |
*
* @param {Svc_Ai_App_Rescue_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_tlm_1 = /** @type {((inputs?: Svc_Ai_App_Rescue_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_tlm_1(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_tlm_1(inputs)
	return en_svc_ai_app_rescue_tlm_1(inputs)
});
export { svc_ai_app_rescue_tlm_1 as "svc_ai-app-rescue_tlm_1" }